module.exports = __webpack_public_path__ + "r-v3/img/empty_note.01410849.svg";